import React from "react";
import Paginator from "./Paginator.jsx";
import Flash from "./Flash.jsx";
import Currency from "./currency.js";
class Payments extends React.Component {
  constructor(props){
    super(props);
    this.RESULTS_PER_PAGE = 10;
    this.state = {
      payments: [],
      count: 0,
      page: 0,
      limit: this.RESULTS_PER_PAGE,
      flash_messages: [],
      flash_timestamp: ""
    };

    this.retrieve_payments = this.retrieve_payments.bind(this);

  }

  componentDidMount(){
    this.retrieve_payments(this.state.page, this.RESULTS_PER_PAGE);
  }

  retrieve_payments(page, limit){
    fetch(`/payments?offset=${page*this.RESULTS_PER_PAGE}&limit=${limit}&include=PaymentMethod`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'/*,
        'x-csrf-token': this.csrf_token()*/
      }
    }).then((response) => {
      return response.json();
    }).then((json) => {
      if (!json.payments){
        return Flash.add_message(this, "Error encountered in retrieving Payments.", 'danger', 5);
      }
      this.setState({
        page: page,
        payments: json.payments,
        count: json.count
      });
    })
  }

  render () {
    return (
        <div className="psintegril-card">
          <Flash messages={this.state.flash_messages} timestamp={this.state.flash_timestamp} on_update={(flash_state) => this.setState(flash_state)} />
          <h1>Payments</h1>
          <div className="psintegril-table-container">
            <table className="psintegril-table">
              <tbody>
                <tr>
                  <th>
                    Date ({String(new Date()).slice(25,33)})
                  </th>
                  <th>
                    ID
                  </th>
                  <th>
                    Amount
                  </th>
                  <th>
                    Status
                  </th>
                  <th>
                    Stripe ID
                  </th>
                </tr>
                {this.state.payments.map(
                  (payment, index) => 
                  <tr key={index}>
                    <td>
                      {String(new Date(payment.created_at)).slice(4,24)}
                    </td>
                    <td>
                      <a href={`/s/payments/${payment.id}`}>{payment.id}</a>
                    </td>
                    <td>
                      {payment.currency.toUpperCase()} {Currency.display(payment.amount, payment.currency)}
                    </td>
                    <td>
                      {payment.status}
                    </td>
                    <td>
                      {payment.id_gateway}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paginator on_page_change={(page) => {
            this.setState({page: page});
            this.retrieve_payments(page, this.RESULTS_PER_PAGE);
          }} results={this.state.count} per_page={this.RESULTS_PER_PAGE} page={this.state.page} />
        </div>
    );
  }
}

export default Payments;
